import {
  configureLinesChartValidates,
  configureDataValidate,
  resultsetWithFields,
} from 'vlcishared';
import { COLORS } from '../constants/constants';
import { yAxisFormat, configureDataLine, calculateXAxisStart } from '../common';
import { TEXTS_GAUGE_YEAR } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';

export function echartViePrincCiutat(vis, datos) {
  const color = COLORS.slice();
  const datosArray = datos.resultset || datos;

  // Obtenemos los datos ordenados
  const cleanData = configureDataLine(datosArray, color, false);
  const date = cleanData[1];
  const xAxisData = Array.from(date.values());
  const legendData = cleanData[2];
  const datazoomStart = calculateXAxisStart(date.size);

  // Obtenemos los datos para formar la serie
  const resultSet = resultsetWithFields(datos);
  const kpiValidList = [
    'KpiValid-30-Accesos-Vias-Coches',
    'KpiValid-365-Accesos-Vias-Coches',
  ];
  const kpiInvalidList = ['Kpi-Accesos-Vias-Coches'];
  const seriesData = configureDataValidate(
    resultSet,
    cleanData[0],
    kpiValidList,
    kpiInvalidList,
  );

  const specificOptions = {
    title: {
      text: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get('tituloGraficaVias')}`,
    },
    legend: {
      show: true,
      data: legendData,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
    },
    yAxis: {
      name: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get(
        'unidadMedidaVehículos',
      )}`,
      axisLabel: {
        formatter: yAxisFormat,
      },
    },
    dataZoom: {
      show: true,
      data: xAxisData,
      start: datazoomStart,
    },
    toolbox: {
      show: true,
    },
  };

  configureLinesChartValidates(
    'chartViePrincCiutat',
    seriesData,
    specificOptions,
  );
}
